import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import AdminCardHint from "./cardMessage";
import AdminUsersHint from "./usersMessage";
import { useLocation } from "react-router-dom";
import LineChart from "@general/lineChart";
import { Row, Col, Divider } from "antd";
import BarChart from "@general/barChart";
import AdminConsultationsHint from "./consultationMessage";
function AdminDashboard(props) {
  const ADMINDASHBOARDDATA = gql`
    query adminDashboardData(
      $confirmStatus: ConfirmStatus!
      $cardStatus: CardStatus!
      $chartTime: ChartTime!
    ) {
      getPurchasesCount(searchInput: { isNewConsultation: true })
      getUsersCount(searchInput: { confirmStatus: [$confirmStatus] })
      getCardsCount(searchInput: { cardStatus: [$cardStatus] })
      getFunancialChart(searchInput: {}, chartTime: $chartTime) {
        labels
        incomesValues
        expendituresValues
        profitsValues
      }
    }
  `;
  const [pendingUsersCount, setPendingUsersCount] = useState(null);
  const [issuingCardsCount, setIssuingCardsCount] = useState(null);
  const [chartLabels, setChartLabels] = useState();
  const [expendituresValues, setExpendituresValues] = useState();
  const [incomesValues, setIncomesValues] = useState();
  const [profitsValues, setProfitsValues] = useState();
  const [consultationsCount, setConsultationsCount] = useState(0);
  const [chartTime, setChartTime] = useState("MONTHLY");

  const [getAdminData, adminData] = useLazyQuery(ADMINDASHBOARDDATA, {
    fetchPolicy: "no-cache",
    onCompleted({
      getUsersCount,
      getCardsCount,
      getFunancialChart,
      getPurchasesCount: newConsultationsCount,
    }) {
      setPendingUsersCount(getUsersCount);
      setIssuingCardsCount(getCardsCount);
      setChartLabels(getFunancialChart?.labels);
      setExpendituresValues(getFunancialChart?.expendituresValues);
      setIncomesValues(getFunancialChart?.incomesValues);
      setProfitsValues(getFunancialChart?.profitsValues);
      setConsultationsCount(newConsultationsCount);
    },
    onError(err) {
      console.log("خطا: " + err);
    },
  });
  const location = useLocation();
  useEffect(() => {
    getAdminData({
      variables: {
        confirmStatus: "PENDING",
        cardStatus: "ISSUING",
        chartTime,
      },
    });
  }, [location.pathname, chartTime]);
  return (
    <>
      <Row gutter={[30, 30]}>
        <Col xs={24} md={12}>
          <AdminUsersHint pendingUsersCount={pendingUsersCount} />
          <AdminCardHint issuingCardsCount={issuingCardsCount} />
          <AdminConsultationsHint consultationsCount={consultationsCount}/>
        </Col>
        </Row>
        {pendingUsersCount||issuingCardsCount||consultationsCount ? <Divider/> : null}
      <Row gutter={[30, 30]}>
        <Col xs={24} md={18}>
          <LineChart
            labels={chartLabels}
            firstChartValues={expendituresValues}
            secondChartValues={incomesValues}
          />
          <BarChart labels={chartLabels} values={profitsValues} />
        </Col>
      </Row>
    </>
  );
}

export default AdminDashboard;
